import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunner, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import loadSession from "@insite/client-framework/Store/Context/Handlers/LoadSession";
import { addAccessorial, AddAccessorialApiParameters } from "@tKgpco/Services/AccessorialsService";
import {
    FeatureRolePermissionsProperty,
    RolesCollection,
    updateRolePermissions,
} from "@tKgpco/Services/SecurityRolesService";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";
import { Accessorials } from "@tKgpco/Store/Data/Accessorials/AccessorialsState";

type Parameters = FeatureRolePermissionsProperty & HasOnSuccess & HasOnError;
type HandlerType = CustomApiHandler<Parameters, any>;

export const PopulateApiParameters: HandlerType = props => {
    const { isEdit, roleName, customerNumber, featureDetails } = props.parameter;
    props.apiParameter = {
        isEdit,
        roleName,
        customerNumber,
        featureDetails,
    };
};

export const CreateRole: HandlerType = async props => {
    try {
        props.apiResult = await updateRolePermissions(props.parameter);
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }
        throw error;
    }
};

export const ExecuteOnSuccess: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult);
    props.dispatch(loadSession({ isSessionUpdate: true }));
};

export const chain = [PopulateApiParameters, CreateRole, ExecuteOnSuccess];

const updateRole = createHandlerChainRunner(chain, "updateRole");
export default updateRole;
